import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';

import Modal from '../../components/ui-controls/Modal';
import theme from '../../style/theme';
import Text from '../ui-controls/Text';

type NoTillPaymentServiceAvailableModalProps = {
  isVisible: boolean;
  onOK: () => void;
};

const NoTillPaymentServiceAvailableModal = ({
  isVisible,
  onOK,
}: NoTillPaymentServiceAvailableModalProps) => {
  return (
    <Modal onBackdropPress={onOK} isVisible={isVisible} title="Online Payment Not Available">
      <View style={styles.buttonsContainer}>
        <Text style={styles.infoText}>
          It appears that online payments are not available at this store.
        </Text>
        <Pressable testID="ok-button" onPress={onOK} style={[styles.okButton, styles.button]}>
          <Text style={styles.button.text}>{'OK'}</Text>
        </Pressable>
      </View>
    </Modal>
  );
};

export default NoTillPaymentServiceAvailableModal;

const styles = StyleSheet.create({
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  okButton: {
    marginTop: 8,
    marginBottom: 8,
  },
  disabledButton: {
    borderColor: 'darkgray',
    backgroundColor: 'lightgrey',
    paddingVertical: 8,
    borderRadius: 4,
    paddingHorizontal: 16,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600' as const,
    },
  },
  checkboxContainer: {
    flexDirection: 'row',
  },
  checkbox: {
    alignSelf: 'center',
  },
  label: {
    margin: 8,
  },
  infoText: {
    fontWeight: '600',
    fontSize: 16,
    color: theme.colour.text.content.primary,
    marginTop: 16,
  },
});
